"use client";

import { useTonality } from "@/contexts/studio-context";
import { HarmonyAtlas } from "./harmony-atlas";
import type { HarmonyFocus } from "./types";

interface HarmonySidebarProps {
  focus: HarmonyFocus;
  onFocusChange: (focus: HarmonyFocus) => void;
}

/**
 * Sidebar de la tab Harmonie : remplit le slot de 200px piloté par
 * `StudioPage`. Lit la tonalité courante directement depuis le studio
 * (jamais dupliquée localement) et délègue le rendu à `HarmonyAtlas`.
 *
 * Quand aucune tonalité n&apos;est sélectionnée, affiche un placeholder
 * cohérent avec `PracticeStructureSidebar`.
 */
export function HarmonySidebar({ focus, onFocusChange }: HarmonySidebarProps) {
  const [tonality] = useTonality();

  if (!tonality) {
    return (
      <div className="flex-1 min-h-0 flex items-center justify-center px-4 py-6 text-[12px] text-text-muted italic">
        Sélectionne une tonalité dans la barre d&apos;outils.
      </div>
    );
  }

  return (
    <HarmonyAtlas
      tonality={tonality}
      focus={focus}
      onFocusChange={onFocusChange}
    />
  );
}
